'use client';

import { OtpProvider, TOtpConfig, useOtpContext } from '../model';
import { useMobile } from '@shared/hooks';
import { Dialog, Drawer } from '@shared/ui';

interface OtpModalProps {
  config: TOtpConfig;
  children: React.ReactNode;
}

const OtpRoot = ({ children }: { children: React.ReactNode }) => {
  const { open, setOpen, send, hasOpenedOnce } = useOtpContext();
  const isMobile = useMobile();
  const Root = isMobile ? Drawer : Dialog;

  const handleOpenChange = (nextOpen: boolean) => {
    if (nextOpen && !hasOpenedOnce && send && !send.isSuccess) return;

    setOpen(nextOpen);
  };

  return (
    <Root open={open} onOpenChange={handleOpenChange}>
      {children}
    </Root>
  );
};

export const OtpHandler = ({ config, children }: OtpModalProps) => {
  return (
    <OtpProvider config={config}>
      <OtpRoot>{children}</OtpRoot>
    </OtpProvider>
  );
};
